import Styled from 'styled-components';

export const ChangeItemContainer = Styled.div`
  margin-bottom: 10px;
`;

export const ChangesList = Styled.div`
  display: flex;
  justify-content: space-around;
`;

export const ChangeItemTitle = Styled.div`
  color: #C4C3C7;
  font-size: 18px;
  font-weight: 500;
`;

export const ChangeItemValue = Styled.div`
  font-size: 24px;
  font-weight: 500;
  color: #45465B;
`;

